const THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000;

/**
 * YouTube API ToS III.E.4.a-g: Stats older than 30 days must not be displayed.
 * Returns true if YouTube content's lastScraped is older than 30 days.
 * Returns false for non-YouTube content.
 */
export const isYouTubeDataStale = (content) => {
  if (!content) return false;
  if (content.platform?.toLowerCase() !== 'youtube') return false;
  if (!content.lastScraped) return true;

  const lastScrapedDate = new Date(content.lastScraped);
  return (Date.now() - lastScrapedDate.getTime()) > THIRTY_DAYS_MS;
};
